import React from "react";
import { any, bool, func, object, string } from "prop-types";
import GenericStep from "./GenericStep";
import TagsInput from "./TagsInput";
import useStepTags from "./useStepTags";

function TiktokStep({
  form,
  onFormDisabled,
  contractName,
  visible,
  campaignSteps,
  companyName,
  platform,
  link,
  emailTemplates,
  addEmailTemplate,
}) {
  const {
    tags,
    setTags,
    tagsInputComponent,
    formPreSubmit,
    setExistingStep,
    formReset,
  } = useStepTags();

  const handleFormDisabled = disabled => {
    formReset(!disabled, onFormDisabled);
  };

  return (
    <GenericStep
      form={form}
      onFormDisabled={handleFormDisabled}
      stepType="tiktok"
      contractName={contractName}
      onExistingFieldSelect={setExistingStep}
      invisibleFormFields={["tags"]}
      formPreSubmit={formPreSubmit}
      visible={visible}
      campaignSteps={campaignSteps}
      companyName={companyName}
      platform={platform}
      link={link}
      emailTemplates={emailTemplates}
      addEmailTemplate={addEmailTemplate}
    >
      <TagsInput
        ref={tagsInputComponent}
        label="Add TikTok Tags"
        tags={tags}
        setTags={setTags}
      />
    </GenericStep>
  );
}

TiktokStep.propTypes = {
  form: any,
  onFormDisabled: func,
  contractName: string,
  visible: bool,
  campaignSteps: object,
  companyName: string,
  platform: string,
  link: string,
  emailTemplates: object,
  addEmailTemplate: func,
};

export default TiktokStep;
